import { getDefaultSortOrder, List, ShowButton, useTable } from '@refinedev/antd';
import { Button, Form, Input, Switch, Table } from 'antd';
import { HttpError } from '@refinedev/core';
import { IUser, IUserFilterVariables } from '../../interfaces/user';
import { fetcher } from '../../utils/fetcher';
import { useState } from 'react';

export const UserList = () => {
  const { tableQueryResult, tableProps, sorters, searchFormProps } = useTable<
    IUser,
    HttpError,
    IUserFilterVariables
  >({
    sorters: {
      initial: [
        {
          field: 'createdAt',
          order: 'desc',
        },
      ],
    },
    meta: {
      fields: [
        'id',
        'email',
        'useSitting',
        'createdAt',
        {
          profile: ['name'],
        },
      ],
    },
    onSearch: (params) => {
      const { id, email, firebaseId } = params;
      return [
        {
          field: 'id',
          operator: 'eq',
          value: id,
        },
        {
          field: 'email',
          operator: 'contains',
          value: email,
        },
        {
          field: 'firebaseId',
          operator: 'eq',
          value: firebaseId,
        },
      ];
    },
  });

  const [switchLoadingDict, setSwitchLoadingDict] = useState<{ [key in string]: boolean }>({});

  const SearchForm = () => (
    <Form data-test-id="SearchForm" layout="inline" {...searchFormProps}>
      <Form.Item label="ID" name="id">
        <Input placeholder="ID" />
      </Form.Item>
      <Form.Item label="Email" name="email">
        <Input placeholder="Email" />
      </Form.Item>
      <Form.Item label="UID" name="firebaseId">
        <Input placeholder="FirebaseId" />
      </Form.Item>
      <Button htmlType="submit" type="primary">
        検索
      </Button>
    </Form>
  );

  return (
    <List resource="users" headerProps={{ title: 'ユーザー一覧' }} headerButtons={<SearchForm />}>
      <Table
        {...tableProps}
        rowKey="id"
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total) => `全${total}件`,
        }}
      >
        <Table.Column
          dataIndex="email"
          title="Email"
          sorter={{ multiple: 1 }}
          defaultSortOrder={getDefaultSortOrder('email', sorters)}
        />
        <Table.Column
          dataIndex="createdAt"
          title="CreatedAt"
          sorter={{ multiple: 2 }}
          defaultSortOrder={getDefaultSortOrder('createdAt', sorters)}
        />
        <Table.Column<IUser>
          dataIndex="actions"
          title="シッター利用"
          render={(_, record) => (
            <Switch
              checked={record.useSitting}
              loading={switchLoadingDict[record.id] ?? false}
              onChange={async () => {
                setSwitchLoadingDict((prev) => ({ ...prev, [record.id]: true }));
                await fetcher(`/admin/users/${record.id}/toggle_use_sitting`, {
                  method: 'PUT',
                });
                tableQueryResult.refetch();
                setSwitchLoadingDict((prev) => ({ ...prev, [record.id]: false }));
              }}
            />
          )}
        />
        <Table.Column<IUser>
          dataIndex="actions"
          render={(_, record) => <ShowButton hideText size="small" recordItemId={record.id} />}
        />
      </Table>
    </List>
  );
};
